import { render, staticRenderFns } from "./SearchSortTab.vue?vue&type=template&id=a0c7791a&scoped=true&"
import script from "./SearchSortTab.vue?vue&type=script&lang=js&"
export * from "./SearchSortTab.vue?vue&type=script&lang=js&"
import style0 from "./SearchSortTab.vue?vue&type=style&index=0&id=a0c7791a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c7791a",
  null
  
)

export default component.exports